var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "573px",
    height: "429px",
    viewBox: "0 0 573 429",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7C806295-96C9-457B-B63B-638A083C2E63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC68\\uD83C\\uDFFD\\u200D\\uD83D\\uDCBBProfesor-ordenado\\uD83D\\uDC68\\uD83C\\uDFFD\\u200D\\uD83D\\uDCBB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.Desktop-HD/-sala-de-lectura-Copy-4",
    transform: "translate(-769.000000, -297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-133",
    transform: "translate(769.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.002667,385 C362.000139,384.927269 361.708946,377.486337 358.365281,370.209177 C354.040862,360.796372 346.796928,356.024105 336.833676,356.024105 C326.841608,356.024105 319.64014,360.825363 315.429468,370.295131 C312.193989,377.570257 312.000872,384.90489 311.998849,384.978638 L308,384.890649 C308.007078,384.56158 309.030803,352 336.833676,352 C364.615822,352 365.989889,384.540219 366,384.868779 L362.002667,385 Z",
    id: "Fill-1",
    fill: "#DAF4F1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#E5D7ED",
    points: "357 385 347.831237 385 337.932495 359.218491 324.198719 385 313 385 338.562863 337"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFF9E6",
    points: "141 290 473 290 473 19 141 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFECB1",
    points: "141 49 473 49 473 19 141 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,33.5 C428,35.4328358 426.432836,37 424.5,37 C422.567164,37 421,35.4328358 421,33.5 C421,31.5671642 422.567164,30 424.5,30 C426.432836,30 428,31.5671642 428,33.5",
    id: "Fill-8",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,33.5 C442,35.4328358 440.432836,37 438.5,37 C436.567164,37 435,35.4328358 435,33.5 C435,31.5671642 436.567164,30 438.5,30 C440.432836,30 442,31.5671642 442,33.5",
    id: "Fill-9",
    fill: "#DAF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,33.5 C455,35.4328358 453.432836,37 451.5,37 C449.567164,37 448,35.4328358 448,33.5 C448,31.5671642 449.567164,30 451.5,30 C453.432836,30 455,31.5671642 455,33.5",
    id: "Fill-10",
    fill: "#FFD963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFCF1",
    points: "472.795063 49 141 289.996954 473 290"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#CEB2DD",
    points: "155 77 188 77 188 64 155 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,162.5 C390,189.158602 376.707612,212.718621 356.393722,226.903045 C343.671414,235.789416 328.199396,241 311.500254,241 C268.149208,241 233,205.851187 233,162.5 C233,145.894377 238.151067,130.503168 246.949939,117.820994 C261.120587,97.3860042 284.747657,84 311.500254,84 C354.857911,84 390,119.142202 390,162.5",
    id: "Fill-13",
    fill: "#7174C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,182.338132 C370,198.909513 364.855963,214.275583 356.079498,226.931606 C343.389588,235.799653 327.956969,241 311.300352,241 C268.0597,241 233,205.923156 233,162.661361 C233,146.090487 238.137443,130.730507 246.914415,118.074484 C259.603818,109.200347 275.043538,104 291.700155,104 C334.940807,104 370,139.069739 370,182.338132",
    id: "Fill-14",
    fill: "#6367C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,197 L313,197 C309.6864,197 307,194.32263 307,191.020167 L307,119.979833 C307,116.67737 309.6864,114 313,114 C316.3136,114 319,116.67737 319,119.979833 L319,191.020167 C319,194.32263 316.3136,197 313,197",
    id: "Fill-15",
    fill: "#E6E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,207.5 C320,211.089842 317.089724,214 313.500262,214 C309.910276,214 307,211.089842 307,207.5 C307,203.910158 309.910276,201 313.500262,201 C317.089724,201 320,203.910158 320,207.5",
    id: "Fill-16",
    fill: "#E6E7F5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFECB1",
    points: "487 233 573 233 573 19 487 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#6367C1",
    points: "499 94 562 94 562 31 499 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.500245,76 L530.500245,76 C529.119651,76 528,74.8388899 528,73.4060415 L528,42.5939585 C528,41.161618 529.119651,40 530.500245,40 L530.500245,40 C531.880838,40 533,41.161618 533,42.5939585 L533,73.4060415 C533,74.8388899 531.880838,76 530.500245,76",
    id: "Fill-19",
    fill: "#E6E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,80.5 C533,81.8807356 531.880736,83 530.5,83 C529.119264,83 528,81.8807356 528,80.5 C528,79.1192644 529.119264,78 530.5,78 C531.880736,78 533,79.1192644 533,80.5",
    id: "Fill-20",
    fill: "#E6E7F5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#CEB2DD",
    points: "559 14 573 14 573 0 559 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#F1E8F5",
    points: "568.023422 10 563 4.89785168 563.976578 4 569 9.10214832"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#F1E8F5",
    points: "563.976578 10 563 9.10214832 568.023422 4 569 4.89785168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.002521,111 L508.997479,111 C508.446798,111 508,110.552578 508,110 C508,109.447422 508.446798,109 508.997479,109 L552.002521,109 C552.553202,109 553,109.447422 553,110 C553,110.552578 552.553202,111 552.002521,111",
    id: "Fill-24",
    fill: "#FFE38C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.994391,121 L516.005609,121 C515.45044,121 515,120.552578 515,120 C515,119.447422 515.45044,119 516.005609,119 L543.994391,119 C544.54956,119 545,119.447422 545,120 C545,120.552578 544.54956,121 543.994391,121",
    id: "Fill-25",
    fill: "#FFE38C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.002521,140 L508.997479,140 C508.446798,140 508,139.552578 508,139 C508,138.447422 508.446798,138 508.997479,138 L552.002521,138 C552.553202,138 553,138.447422 553,139 C553,139.552578 552.553202,140 552.002521,140",
    id: "Fill-26",
    fill: "#FFE38C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.994391,130 L516.005609,130 C515.45044,130 515,129.552578 515,129 C515,128.447422 515.45044,128 516.005609,128 L543.994391,128 C544.54956,128 545,128.447422 545,129 C545,129.552578 544.54956,130 543.994391,130",
    id: "Fill-27",
    fill: "#FFE38C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FFE38C",
    points: "499 221 562 221 562 158 499 158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,380 L326,380 L326,357.444579 C326,356.094746 327.050957,355 328.346796,355 L331.653204,355 C332.949529,355 334,356.094746 334,357.444579 L334,380 Z",
    id: "Fill-29",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5,375 L328.5,375 C328.223897,375 328,374.685715 328,374.298149 L328,360.701851 C328,360.314285 328.223897,360 328.5,360 C328.776103,360 329,360.314285 329,360.701851 L329,374.298149 C329,374.685715 328.776103,375 328.5,375",
    id: "Fill-30",
    fill: "#BA93CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.5,375 L332.5,375 C332.223897,375 332,374.685715 332,374.298149 L332,360.701851 C332,360.314285 332.223897,360 332.5,360 C332.776103,360 333,360.314285 333,360.701851 L333,374.298149 C333,374.685715 332.776103,375 332.5,375",
    id: "Fill-31",
    fill: "#BA93CF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#F1E8F5",
    points: "329 394 332 394 332 380 329 380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.40089,367 L334.371861,361.132896 C332.663341,360.656747 331.651146,358.833774 332.110822,357.062079 L333.045311,353.459564 C333.504986,351.687869 335.262956,350.638247 336.971476,351.11492 L358,356.982023 L355.40089,367 Z",
    id: "Fill-33",
    fill: "#9A61B8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#C19ED3",
    points: "336.59989 402 330 400.28721 340.40011 363 347 364.71279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.624917,364.936429 L357,364.465245 L358.11452,360 L359.739437,360.471684 C360.647479,360.734787 361.185251,361.741681 360.941189,362.721063 L360.71151,363.640923 C360.466984,364.619805 359.532959,365.200032 358.624917,364.936429",
    id: "Fill-35",
    fill: "#C19ED3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#DAF4F1",
    points: "306 429 368 429 368 385 306 385"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#D3F2EE",
    points: "306 385 368 429 368 385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.742983,218 L14.2575242,218 C6.38320935,218 0,211.673055 0,203.868651 L0,181.131852 C0,173.326945 6.38320935,167 14.2575242,167 L159.742983,167 C167.616791,167 174,173.326945 174,181.131852 L174,203.868651 C174,211.673055 167.616791,218 159.742983,218",
    id: "Fill-38",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.742983,429 L14.2575242,429 C6.38320935,429 0,422.624482 0,414.760161 L0,238.239839 C0,230.375518 6.38320935,224 14.2575242,224 L159.742983,224 C167.616791,224 174,230.375518 174,238.239839 L174,414.760161 C174,422.624482 167.616791,429 159.742983,429",
    id: "Fill-39",
    fill: "#F1E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.443642,315 L92.5568652,315 C86.7266518,315 82,310.273855 82,304.443642 L82,246.556358 C82,240.726145 86.7266518,236 92.5568652,236 L150.443642,236 C156.273855,236 161,240.726145 161,246.556358 L161,304.443642 C161,310.273855 156.273855,315 150.443642,315",
    id: "Fill-40",
    fill: "#E5D7ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,251 C98,253.761473 95.7614725,256 93,256 C90.2385275,256 88,253.761473 88,251 C88,248.238527 90.2385275,246 93,246 C95.7614725,246 98,248.238527 98,251",
    id: "Fill-41",
    fill: "#DAF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,251 C117,253.761473 114.761473,256 112,256 C109.238527,256 107,253.761473 107,251 C107,248.238527 109.238527,246 112,246 C114.761473,246 117,248.238527 117,251",
    id: "Fill-42",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,251 C136,253.761473 133.761473,256 131,256 C128.238527,256 126,253.761473 126,251 C126,248.238527 128.238527,246 131,246 C133.761473,246 136,248.238527 136,251",
    id: "Fill-43",
    fill: "#DAF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,251 C155,253.761473 152.761473,256 150,256 C147.238527,256 145,253.761473 145,251 C145,248.238527 147.238527,246 150,246 C152.761473,246 155,248.238527 155,251",
    id: "Fill-44",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.77973,286 L103.22027,286 C100.33723,286 98,283.662714 98,280.779604 L98,270.219888 C98,267.336778 100.33723,265 103.22027,265 L113.77973,265 C116.66277,265 119,267.336778 119,270.219888 L119,280.779604 C119,283.662714 116.66277,286 113.77973,286",
    id: "Fill-45",
    fill: "#C7EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.472133,286 L130.528375,286 C127.475013,286 125,283.524987 125,280.472133 L125,270.527867 C125,267.475013 127.475013,265 130.528375,265 L140.472133,265 C143.524987,265 146,267.475013 146,270.527867 L146,280.472133 C146,283.524987 143.524987,286 140.472133,286",
    id: "Fill-46",
    fill: "#C7EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.497215,296 L90.5027846,296 C89.1204149,296 88,294.880718 88,293.499746 C88,292.119282 89.1204149,291 90.5027846,291 L152.497215,291 C153.879585,291 155,292.119282 155,293.499746 C155,294.880718 153.879585,296 152.497215,296",
    id: "Fill-47",
    fill: "#C19ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.763134,309 L100.236866,309 C99.0014269,309 98,307.998573 98,306.763134 L98,303.236866 C98,302.001427 99.0014269,301 100.236866,301 L103.763134,301 C104.998573,301 106,302.001427 106,303.236866 L106,306.763134 C106,307.998573 104.998573,309 103.763134,309",
    id: "Fill-48",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.763134,309 L113.236866,309 C112.001427,309 111,307.998573 111,306.763134 L111,303.236866 C111,302.001427 112.001427,301 113.236866,301 L116.763134,301 C117.998573,301 119,302.001427 119,303.236866 L119,306.763134 C119,307.998573 117.998573,309 116.763134,309",
    id: "Fill-49",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.763134,309 L126.236866,309 C125.001427,309 124,307.998573 124,306.763134 L124,303.236866 C124,302.001427 125.001427,301 126.236866,301 L129.763134,301 C130.998573,301 132,302.001427 132,303.236866 L132,306.763134 C132,307.998573 130.998573,309 129.763134,309",
    id: "Fill-50",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.763134,309 L140.236866,309 C139.001427,309 138,307.998573 138,306.763134 L138,303.236866 C138,302.001427 139.001427,301 140.236866,301 L143.763134,301 C144.998573,301 146,302.001427 146,303.236866 L146,306.763134 C146,307.998573 144.998573,309 143.763134,309",
    id: "Fill-51",
    fill: "#CEB2DD"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#CEB2DD",
    points: "16 429 24 429 24 224 16 224"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#CEB2DD",
    points: "35 429 43 429 43 224 35 224"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#CEB2DD",
    points: "54 429 62 429 62 224 54 224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.77973,385 L115.22027,385 C112.33723,385 110,382.662714 110,379.779604 L110,369.219888 C110,366.336778 112.33723,364 115.22027,364 L125.77973,364 C128.66277,364 131,366.336778 131,369.219888 L131,379.779604 C131,382.662714 128.66277,385 125.77973,385",
    id: "Fill-55",
    fill: "#DAF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,374.5 C123,375.880728 121.880728,377 120.5,377 C119.119272,377 118,375.880728 118,374.5 C118,373.119272 119.119272,372 120.5,372 C121.880728,372 123,373.119272 123,374.5",
    id: "Fill-56",
    fill: "#C7EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2411883,197 L19.7593152,197 C17.1309164,197 15,194.761613 15,192 L15,192 C15,189.238387 17.1309164,187 19.7593152,187 L66.2411883,187 C68.8695871,187 71,189.238387 71,192 L71,192 C71,194.761613 68.8695871,197 66.2411883,197",
    id: "Fill-57",
    fill: "#BA93CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.763134,196 L120.236866,196 C119.001427,196 118,194.998573 118,193.763134 L118,190.236866 C118,189.001427 119.001427,188 120.236866,188 L123.763134,188 C124.998573,188 126,189.001427 126,190.236866 L126,193.763134 C126,194.998573 124.998573,196 123.763134,196",
    id: "Fill-58",
    fill: "#F1E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.763134,196 L133.236866,196 C132.001427,196 131,194.998573 131,193.763134 L131,190.236866 C131,189.001427 132.001427,188 133.236866,188 L136.763134,188 C137.998573,188 139,189.001427 139,190.236866 L139,193.763134 C139,194.998573 137.998573,196 136.763134,196",
    id: "Fill-59",
    fill: "#F1E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.763134,196 L146.236866,196 C145.001427,196 144,194.998573 144,193.763134 L144,190.236866 C144,189.001427 145.001427,188 146.236866,188 L149.763134,188 C150.998573,188 152,189.001427 152,190.236866 L152,193.763134 C152,194.998573 150.998573,196 149.763134,196",
    id: "Fill-60",
    fill: "#F1E8F5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-128",
    fill: "#9A61B8",
    points: "518 382 526.29257 420 551.170794 420 558 382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.674303,382 C543.674303,382 539.169799,369.012575 546.570092,358.751362 C553.970893,348.489643 558.744785,347.681689 559.762471,341.434964 C561.532007,330.572083 555.852547,327.51369 556.585119,321.319548 C557.671294,312.138808 567.632544,315.502585 566.720888,304.597233 C565.996433,295.939287 571.214231,280.087116 555.579609,288.282941 C541.564355,295.629858 537.882725,316.742829 535.710883,337.185876 C533.538534,357.628923 537.038036,382 537.038036,382 L543.674303,382 Z",
    id: "Fill-129",
    fill: "#DAF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.138861,382 C530.138861,382 534.221264,370.09481 527.514315,360.688573 C520.807872,351.281827 516.481314,350.541924 515.55878,344.815326 C513.954835,334.857729 519.102322,332.05405 518.438603,326.375861 C517.454398,317.960237 508.426708,321.044182 509.253197,311.047348 C509.909334,303.110725 505.180905,288.579697 519.34951,296.092864 C532.05116,302.827401 535.387448,322.181043 537.355857,340.920138 C539.324267,359.659742 536.153277,382 536.153277,382 L530.138861,382 Z",
    id: "Fill-130",
    fill: "#C19ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.990884,383 C539.881444,383 539.78134,382.928265 539.752294,382.819391 C539.736215,382.757831 538.099277,376.593217 538.001766,370.82289 C537.901143,364.868901 542.111228,347.907435 547.904309,341.257466 C551.756508,336.835855 550.516356,331.203909 549.203071,325.24178 C548.51427,322.113939 547.80213,318.879768 547.84518,315.759049 C547.968624,306.800339 554.525195,301.115991 554.591585,301.059011 C554.694283,300.971504 554.850404,300.982697 554.939616,301.083431 C555.028828,301.184674 555.017936,301.337301 554.915238,301.424807 C554.850922,301.479753 548.459291,307.02928 548.338439,315.765663 C548.295908,318.830927 549.002862,322.038134 549.685438,325.139011 C551.025176,331.222733 552.290743,336.968131 548.279311,341.572387 C542.555732,348.142481 538.39544,364.921812 538.495026,370.815258 C538.591499,376.526061 540.212877,382.63573 540.229475,382.696781 C540.264226,382.825496 540.185388,382.957773 540.053644,382.99186 C540.032897,382.997456 540.011631,383 539.990884,383",
    id: "Fill-131",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.27705,383 C533.271512,383 533.265974,383 533.260436,383 C533.128024,382.989821 533.028841,382.874798 533.0374,382.741452 C533.052504,382.525656 534.481343,361.118107 532.295289,355.407153 C531.829079,354.18974 531.137315,352.812006 530.404771,351.35284 C527.873842,346.31065 524.724153,340.035268 526.336757,332.511427 C527.584852,326.689522 524.538373,322.512551 521.85137,318.827228 C520.143106,316.48503 518.667445,314.462453 518.667445,312.43377 C518.667445,306.781346 513.117224,300.467284 513.061339,300.404174 C512.972729,300.304928 512.981288,300.151734 513.079464,300.062158 C513.17764,299.973092 513.329184,299.980217 513.417794,300.080481 C513.651403,300.344118 519.146745,306.598123 519.146745,312.43377 C519.146745,314.30366 520.578605,316.266689 522.236522,318.540179 C524.848006,322.121167 528.098389,326.578062 526.804982,332.613727 C525.228627,339.969614 528.335018,346.16 530.831711,351.133481 C531.569794,352.603844 532.266592,353.992775 532.741361,355.232583 C534.966685,361.043291 533.57611,381.889975 533.515694,382.774534 C533.506631,382.902281 533.401407,383 533.27705,383",
    id: "Fill-132",
    fill: "#F4F4F4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrors);
export default __webpack_public_path__ + "static/media/Errors.4a9cd91ab08294d4bc1ce14c7575e93a.svg";
export { ForwardRef as ReactComponent };